module.exports = __webpack_public_path__ + "img/square-p.17d54283.svg";